// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Popup-summary-1ziyj {\n  font-size: 13px;\n  color: #a3a2a1;\n  text-align: center;\n  max-width: 200px;\n  --fi-size: 14px;\n}\n.Popup-error-1nAIv {\n  color: #f23037;\n}\n", ""]);
// Exports
exports.locals = {
	"summary": "Popup-summary-1ziyj",
	"error": "Popup-error-1nAIv"
};
module.exports = exports;
